var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandMoveTwofinger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes pressIn {\n      0%, 4% { opacity: 0; }\n      10% { opacity: 1; }\n      54% { opacity: 1; }\n      58% { opacity: 0; }\n      100% { opacity: 0; }\n    }\n    @keyframes pan {\n      0%, 16% { transform: translate(0,0); }\n      26% { transform: translate(14px,-10px); }\n      44% { transform: translate(-12px,8px); }\n      58% { transform: translate(0,0); }\n      64%, 100% { transform: translate(0,0); }\n    }\n    @keyframes dotFade {\n      0%, 4% { opacity: 0; }\n      10% { opacity: 1; }\n      54% { opacity: 1; }\n      56% { opacity: 0; }\n      100% { opacity: 0; }\n    }\n    @keyframes ringGrow {\n      0%, 10% { r: 10; opacity: 0; }\n      14% { r: 10; opacity: 0.4; }\n      54% { r: 18; opacity: 0.2; }\n      60% { r: 22; opacity: 0; }\n      100% { r: 22; opacity: 0; }\n    }\n    @keyframes handFade {\n      0%, 4% { opacity: 1; }\n      8% { opacity: 1; }\n      54% { opacity: 1; }\n      58% { opacity: 1; }\n      100% { opacity: 1; }\n    }\n    .dg { animation: pan 3.8s ease-in-out infinite; }\n    .dot { animation: dotFade 3.8s ease-in-out infinite; }\n    .rng { animation: ringGrow 3.8s ease-in-out infinite; }\n    .hand { animation: handFade 3.8s ease-in-out infinite; }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dg"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hand",
    transform: "translate(35, 40) scale(0.4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ddd",
    stroke: "#eee",
    strokeWidth: 2,
    d: "M248.6,131.5c-2.2-6.2-5.8-10.7-11-13.4-5.2-2.7-10.5-3-16-.9-5.9,2.2-10,6-12.3,11.5-2.3,5.4-2.3,11.3,0,17.5l42.5,115.7c.7,1.9.9,3.4.6,4.7-.3,1.3-.9,2.1-1.9,2.5-1.2.4-2.3.2-3.3-.5s-1.9-2.1-2.6-4l-37.6-103.3c-2.2-6.3-6.1-10.9-11.4-13.6-5.4-2.7-10.9-3-16.7-.9-6.2,2.2-10.4,6.1-12.8,11.6-2.4,5.5-2.4,11.5,0,17.8l52.9,145.2c.4,1.1.5,2,.3,2.8s-.7,1.3-1.5,1.6c-1.2.4-2.3,0-3.5-1.3l-34.1-37.1c-3.4-3.7-7.3-6.5-11.8-8.3-4.4-1.9-9.4-1.8-14.9.1-6.4,2.3-11.1,6.3-13.8,11.7-2.8,5.5-3,11.4-.7,17.7.7,2,1.5,3.8,2.4,5.4.9,1.7,1.9,3.1,3,4.4l53.6,64.6c21.3,25.8,43.9,42.1,67.8,48.9s50.2,5.4,76.7-4.2c22.1-8.1,39.4-19.5,51.9-34.1s19.9-31.7,22.2-51.4c2.3-19.7-.8-41.2-9.2-64.5l-10.8-29.7c-4.8-13.1-11.6-22.9-20.6-29.4-8.9-6.5-17.8-8.2-26.4-5.1-5.8,2.1-7.6,6.1-5.4,11.7l4.2,11.7c.7,2,.9,3.5.6,4.8-.3,1.2-1,2-2.1,2.4-1.2.4-2.3.2-3.3-.4-1-.7-1.9-2.1-2.7-4.1l-2.6-7.5c-3.1-8.5-8.2-14.5-15.1-18.1s-14.3-3.9-22-1.1c-8.2,2.9-10.9,8.2-8.2,15.8l5.9,16.3c.8,2.1,1,3.7.7,4.8s-.9,2-1.9,2.3c-1.3.5-2.4.4-3.4-.3s-1.9-2.1-2.7-4.2l-1.2-3.3-41.5-112.9h-.3Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "rng",
    cx: 85,
    cy: 80,
    r: 13,
    fill: "none",
    stroke: "#999",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 85,
    cy: 80,
    r: 10,
    fill: "#888"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "rng",
    cx: 110,
    cy: 65,
    r: 13,
    fill: "none",
    stroke: "#999",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 110,
    cy: 65,
    r: 10,
    fill: "#888"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandMoveTwofinger);
export default __webpack_public_path__ + "static/media/hand-move-twofinger.3090d2ffbdd74312997957df322ca2f8.svg";
export { ForwardRef as ReactComponent };